<template>
  <v-app-bar app flat class="custom-app-bar">
    <v-container>
      <div class="navbar-content">
        <!-- Brand with logo and text -->
        <div class="brand" @click="$router.push('/')">
          <img
            src="@/assets/HECS-logo-extended-long2.png"
            alt="Health Espresso Logo"
            class="logo-img"
          />
        </div>

        <!-- Right-side auth buttons (optional) -->
        <!--
        <div class="nav-buttons">
          <v-btn class="auth-btn" @click="$router.push('/login')">Login</v-btn>
          <v-btn class="auth-btn" @click="$router.push('/signup')">Register</v-btn>
        </div>
        -->
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: "NavBar",
};
</script>

<style scoped>
.custom-app-bar {
  background: linear-gradient(to right, #ffffff, #f8f9fa);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 0;
  z-index: 1000;
}

/* Navbar layout */
.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

/* Brand section */
.brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}

.logo-img {
  height: 48px;
  width: auto;
  object-fit: contain;
}

.brand-text {
  font-size: 1.3rem;
  font-weight: 600;
  color: #005b20;
  user-select: none;
}

/* Auth buttons (optional) */
.nav-buttons {
  display: flex;
  gap: 0.75rem;
}

.auth-btn {
  background-color: #3b82f6 !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 500;
  padding: 0 1rem;
  border-radius: 6px;
  min-width: 100px;
}

.auth-btn:hover {
  background-color: #2563eb !important;
  color: #ffffff !important;
}

/* Remove Vuetify overlay */
:deep(.auth-btn .v-btn__overlay),
:deep(.auth-btn:hover .v-btn__overlay) {
  background-color: transparent !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .logo-img {
    height: 30px;
  }

  .brand-text {
    font-size: 1.1rem;
  }

  .auth-btn {
    font-size: 0.875rem;
    padding: 0 0.75rem;
  }
}
</style>
